import {CamMachineSummaryModel} from "../../../../3d/cam/machine/api/model/camMachineSummary.model";

export class InsolesSummaryCamDocumentModel {
    documentId: number;
    camMachine: CamMachineSummaryModel;
}
